import io from 'socket.io-client';

let socket = null;

// Mesma lógica de resolução de URL usada em NotificationCenter.js — o backend
// roda na porta 8001 local e em admin-api.futezap.com.br em produção (NÃO é
// o mesmo host do frontend, então window.location.origin não serve aqui).
function socketUrl() {
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    return 'http://localhost:8001';
  }
  return 'https://admin-api.futezap.com.br';
}

// Retorna singleton do socket.io. Autentica com o token que estiver no
// localStorage (community_token para /player/*, token para admin). Se
// nenhum token existir, retorna null.
export function getSocket() {
  const communityToken = localStorage.getItem('community_token');
  const token = communityToken || localStorage.getItem('token');
  if (!token) return null;
  if (socket && socket.connected) return socket;

  socket = io(socketUrl(), { auth: { token }, transports: ['websocket', 'polling'] });

  // O servidor (backend/server.js, io.on('connection')) só coloca o socket
  // nas salas `player_<id>` / `organizer_<id>` quando recebe o evento 'join'
  // — a autenticação via handshake sozinha não basta. Sem isso os eventos
  // emitidos por sala (ex: invite:update) nunca chegam no client.
  const userType = communityToken ? 'player' : 'organizer';
  const userData = JSON.parse(
    localStorage.getItem(communityToken ? 'community_user' : 'user') || '{}'
  );
  if (userData.id) {
    socket.on('connect', () => {
      socket.emit('join', { userId: userData.id, userType });
    });
  }

  return socket;
}
